<template>
	<div class="skillMain">
		<mainLeft />
		<mainRight />
	</div>
</template>

<script>
	import mainLeft from './mainLeft'
	import mainRight from './mainRight'

	export default {
		components: {
			mainLeft,
			mainRight
		}
	}
</script>

<style scoped>
	.skillMain {
		width: 1300px;
		margin: auto;
		overflow: hidden;
	}
</style>
